import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import State from '../State';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import RequestFailed from '../../core/events/RequestFailed';
import EstimationPeriodUpdateSucceed from '../events/EstimationPeriodUpdateSucceed';
import EstimationPeriodUpdateRequested from '../events/EstimationPeriodUpdateRequested';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import { AjaxError } from 'rxjs/internal/observable/dom/AjaxObservable';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(EstimationPeriodUpdateRequested.type),
        mergeMap((event: EstimationPeriodUpdateRequested) =>
            backend
                .put(
                    `${api()}estimation-periods`,
                    JSON.stringify({
                        isOpen: event.estimationPeriod.isOpen,
                        months: event.estimationPeriod.months,
                        openMessage: event.estimationPeriod.openMessage,
                        closeMessage: event.estimationPeriod.closeMessage
                    })
                )
                .pipe(
                    map(() => new EstimationPeriodUpdateSucceed(event.estimationPeriod)),
                    catchError((e: AjaxError) => of(new RequestFailed(e.status)))
                )
        )
    );



// WEBPACK FOOTER //
// ./src/application/admin/epic/estimationPeriodUpdate.ts